var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemWorkflow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.909 17c.603 0 1.091.447 1.091 1s-.488 1-1.091 1H3.09C2.488 19 2 18.553 2 18s.488-1 1.091-1zm7.891 0c.664 0 1.2.447 1.2 1s-.536 1-1.2 1h-3.6c-.664 0-1.2-.447-1.2-1s.536-1 1.2-1zm-7.77-6c.536 0 .97.447.97 1s-.434 1-.97 1H5.97c-.536 0-.97-.447-.97-1s.434-1 .97-1zm7.77 0c.664 0 1.2.447 1.2 1s-.536 1-1.2 1h-3.6c-.664 0-1.2-.447-1.2-1s.536-1 1.2-1zm-7.891-6C13.512 5 14 5.447 14 6s-.488 1-1.091 1H3.09C2.488 7 2 6.553 2 6s.488-1 1.091-1zM20.8 5c.664 0 1.2.447 1.2 1s-.536 1-1.2 1h-3.6c-.664 0-1.2-.447-1.2-1s.536-1 1.2-1z"
})));
export default SvgGemWorkflow;